import React, { ReactElement } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import moment from 'moment-timezone';
import { get, isEmpty } from 'lodash';
import { Victim } from 'containers/PreOpeningPage/typings';
import { VICTIM } from 'containers/data-structure';
import { translate } from 'containers/services/translate';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/messages';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';

export interface ExpertiseVictimProps {
  intl: IntlShape;
  victim: Victim;
  children?: ReactElement | ReactElement[];
  displayExpertise?: boolean;
  sagisVictimInfo: any;
  isBasicManagement?: boolean;
}

const ExpertiseVictim: React.FC<ExpertiseVictimProps> = (
  props,
): JSX.Element => {
  const { victim } = props;
  return (
    <section className="item-container">
      <article className="item">
        {featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO) &&
        !props.isBasicManagement
          ? `${get(
              getVictimFromSagisInfo(
                get(victim, 'victimKey'),
                props.sagisVictimInfo,
              ),
              'victimFirstName',
              '',
            )} ${get(
              getVictimFromSagisInfo(
                get(victim, 'victimKey'),
                props.sagisVictimInfo,
              ),
              'victimLastName',
              '',
            )}`
          : `${victim[VICTIM.FIRST_NAME]} ${victim[VICTIM.LAST_NAME]}`}
      </article>
      {props.displayExpertise && (
        <>
          {!isEmpty(get(victim, ['expertise', 'expertName'])) && (
            <article className="field-expert">
              <div className="label">
                {translate(messages.nameExpertField, props)}
              </div>
              <div className="value">
                {get(victim, ['expertise', 'expertName'])}
              </div>
            </article>
          )}
          {!isEmpty(get(victim, ['expertise', 'address'])) && (
            <article className="field-expert">
              <div className="label">
                {translate(messages.adresseExpertField, props)}
              </div>
              <div className="value">
                {get(victim, ['expertise', 'address'])}
              </div>
            </article>
          )}
          {!isEmpty(get(victim, ['expertise', 'expertiseDate'])) && (
            <article className="field-expert">
              <div className="label">
                {translate(messages.dateExpertiseField, props)}
              </div>
              <div className="value">
                {moment(get(victim, ['expertise', 'expertiseDate'])).format(
                  'DD/MM/YYYY',
                )}
              </div>
            </article>
          )}
        </>
      )}

      <article className="item-form">{props.children}</article>
    </section>
  );
};

ExpertiseVictim.defaultProps = {
  displayExpertise: false,
};

export default injectIntl(ExpertiseVictim);
